// eg. given,
//  "urls": {
//     "100": "https://photo_url_1",
//     "1800": "https://photo_url_2"
// }
// returns https://photo_url_2
export const getPhotoWithMaxDimension = (photoUrlHash) => {
  const key = Object.keys(photoUrlHash).reduce((a, b) => (a > b ? a : b));
  return photoUrlHash[key];
};

export default { getPhotoWithMaxDimension };
